// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"317d2bbe","977":"ee3eae1f"}[chunkId] + ".chunk.js";
};